import { useState } from "react";
import { Clipboard, Check } from "lucide-react";

const CopyableOrderId = ({ orderId }: { orderId: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(orderId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <td className="text-sm font-light text-white/40 flex items-center gap-2">
      <span>{orderId}</span>
      <button onClick={handleCopy} className="text-white/60 hover:text-white">
        {copied ? <Check size={16} /> : <Clipboard size={16} />}
      </button>
    </td>
  );
};

export default CopyableOrderId;
